(function(){
  "use strict";

  const PARTS=["PART_SKIS","PART_SKI_HANDLES","PART_SPINDLES","PART_TRACK","PART_BUMPERS","PART_SEAT"];
  const RAW_PALETTES=[
    ["#090a0c","#202327","#b9ff19","#ffffff","#70757c"],
    ["#090a0c","#0e2c5d","#245cff","#63ddff","#ffffff"],
    ["#ff7b00","#ff4d00","#090a0c","#ffffff","#ffad00"],
    ["#101629","#203562","#9a2cff","#63ddff","#f8fdff"],
    ["#df1d3c","#090a0c","#ffffff","#70757c","#b9ff19"],
    ["#0b1110","#087b55","#00b887","#b9ff19","#ffffff"],
    ["#111111","#3b3d41","#f4dc3c","#ffffff","#b8bdc4"],
    ["#090a0c","#3b241a","#ff7b00","#f4dc3c","#ffffff"],
    ["#0c1117","#0e2c5d","#00acd4","#b9ff19","#ffffff"],
    ["#120d18","#5a21a8","#ef4dff","#63ddff","#ffffff"],
    ["#101214","#3b3d41","#9b6a3c","#f4dc3c","#ffffff"],
    ["#0b0d12","#212324","#6c83ff","#df1d3c","#ffffff"]
  ];
  const PATTERNS=[
    [0,1,2,0,1,3,1,0,2,4],
    [0,0,2,1,0,1,3,0,2,4],
    [1,0,2,1,0,3,0,1,2,4],
    [0,1,3,0,2,1,0,3,2,4]
  ];
  const TOUR_STEPS=[
    {target:".m7x-stage",title:"Build directly on your sled",text:"Every color and material choice updates the live preview. You can also click or touch a colored area on the sled to jump straight to that wrap zone."},
    {target:".m7x-scenes",title:"Choose the clearest backdrop",text:"Use Studio for a dark environment or Arctic for a bright snow environment. Arctic is designed to make black and dark colorways easier to judge."},
    {tab:"presets",target:'[data-m7-action="randomize"]',title:"Generate a complete colorway",text:"Randomize Colors creates a balanced full design. This main randomizer always ignores locks and includes its own three-step Previous history."},
    {tab:"presets",target:".m7x-customize-card",title:"Fine-tune a result",text:"When a colorway is close, open Customize This Colorway to edit individual wrap colors, gradients and sled parts."},
    {tab:"custom",group:"wrap",target:".m7x-zones:not(.parts)",title:"Select and lock the colors you like",text:"Choose any numbered wrap color, then tap its lock. Locked colors stay untouched while you explore variations in the other zones. Use Unlock All whenever you want a clean slate."},
    {tab:"custom",group:"wrap",target:".m7-lock-randomizer",title:"Randomize only the unlocked zones",text:"Randomize Unlocked changes the remaining wrap colors in one clean update. Previous restores up to three complete locked-color variations."},
    {tab:"custom",group:"wrap",target:".m7x-paint",title:"Use solids or seamless gradients",text:"Switch between Solid and Gradient, select M7 or OEM colors, and adjust the transition without creating hard seams between separate vector objects."},
    {tab:"custom",target:".m7x-groups",title:"Edit the sled parts separately",text:"Switch to Sled Parts to color the skis, spindles, rails, bumpers and seat. The locked wrap randomizer leaves these selections unchanged."},
    {target:".m7x-tabs",title:"Finish the complete build",text:"Choose coverage, vinyl type and laminate effect from the remaining tabs. Then Save, Share or Continue when the design is ready."},
    {target:".m7x-nav",title:"Save it or keep moving",text:"Save designs on this device, share a colorway, or continue to sled details and production options."}
  ];
  const STORAGE_KEY="m7-locked-wrap-zones:"+location.pathname;
  const history=[];
  let locked=new Set();
  let busy=false;
  let lastPalette=-1;
  let tourIndex=0;
  let tourRestore=null;

  /* This add-on replaces only the legacy help guide. Mark that guide complete
     immediately so its delayed first-visit launch cannot appear underneath ours. */
  try{localStorage.setItem("m7-editor-walkthrough","complete");}catch(error){}

  try{
    locked=new Set(JSON.parse(localStorage.getItem(STORAGE_KEY)||"[]"));
  }catch(error){
    locked=new Set();
  }

  const wait=()=>new Promise(resolve=>requestAnimationFrame(()=>requestAnimationFrame(resolve)));
  const clone=value=>JSON.parse(JSON.stringify(value));

  function rgb(hex){
    const value=hex.replace("#","");
    return [0,2,4].map(index=>parseInt(value.slice(index,index+2),16));
  }

  function nearestColor(target,library){
    const wanted=rgb(target);
    return library.reduce((best,color)=>{
      const candidate=rgb(color);
      const bestRgb=rgb(best);
      const score=candidate.reduce((sum,value,index)=>sum+(value-wanted[index])**2*[2,4,1][index],0);
      const bestScore=bestRgb.reduce((sum,value,index)=>sum+(value-wanted[index])**2*[2,4,1][index],0);
      return score<bestScore?color:best;
    },library[0]);
  }

  function shuffled(values){
    const result=[...values];
    for(let index=result.length-1;index>0;index--){
      const swap=Math.floor(Math.random()*(index+1));
      [result[index],result[swap]]=[result[swap],result[index]];
    }
    return result;
  }

  function buildVariation(before,unlocked){
    const fallback=[...new Set(RAW_PALETTES.flat())];
    const library=typeof M7_M7_COLORS!=="undefined"&&M7_M7_COLORS.length?M7_M7_COLORS:fallback;
    let paletteIndex=Math.floor(Math.random()*RAW_PALETTES.length);
    if(paletteIndex===lastPalette)paletteIndex=(paletteIndex+1)%RAW_PALETTES.length;
    lastPalette=paletteIndex;
    const palette=RAW_PALETTES[paletteIndex].map(color=>nearestColor(color,library));
    const pattern=PATTERNS[Math.floor(Math.random()*PATTERNS.length)];
    const gradientCount=Math.max(1,Math.min(3,Math.round(.3*unlocked.length)));
    const gradientZones=new Set(shuffled(unlocked).slice(0,gradientCount));
    const paints=clone(before.paints);

    unlocked.forEach(role=>{
      const zoneIndex=Math.max(0,before.activeZones.indexOf(role));
      const startSlot=pattern[zoneIndex%pattern.length]%palette.length;
      let endSlot=(startSlot+(Math.random()>.5?1:2))%palette.length;
      if(endSlot===startSlot)endSlot=(startSlot+1)%palette.length;
      paints[role]={
        a:palette[startSlot],
        b:palette[endSlot],
        mode:gradientZones.has(role)?"gradient":"solid",
        opacity:100
      };
    });

    return{
      paints,
      name:"M7 Mix "+(Math.floor(Math.random()*900)+100)
    };
  }

  function saveLocks(){
    localStorage.setItem(STORAGE_KEY,JSON.stringify([...locked]));
  }

  function activeZones(){
    return window.M7Editor?.getSnapshot?.().activeZones||[];
  }

  function lockIcon(isLocked){
    return isLocked
      ? '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="10" width="14" height="11" rx="2"></rect><path d="M8 10V7a4 4 0 0 1 8 0v3"></path></svg>'
      : '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="10" width="14" height="11" rx="2"></rect><path d="M16 10V7a4 4 0 0 0-7.7-1.5"></path></svg>';
  }

  function updateLock(toggle,role){
    const isLocked=locked.has(role);
    if(toggle.dataset.locked===String(isLocked))return;
    toggle.dataset.locked=String(isLocked);
    toggle.classList.toggle("locked",isLocked);
    toggle.setAttribute("aria-pressed",String(isLocked));
    toggle.setAttribute("aria-label",(isLocked?"Unlock ":"Lock ")+role.replace("_"," "));
    toggle.title=isLocked?"Keep this color during randomizing":"Lock this color";
    toggle.innerHTML=lockIcon(isLocked);
  }

  function injectStyles(){
    if(document.getElementById("m7LockRandomizerStyles"))return;
    const style=document.createElement("style");
    style.id="m7LockRandomizerStyles";
    style.textContent=`
      .m7x-zones:not(.parts) [data-m7-zone^="COLOR_"]{position:relative;padding-right:38px!important}
      .m7-lock-toggle{position:absolute;z-index:4;right:6px;top:50%;width:27px;height:27px;display:grid;place-items:center;transform:translateY(-50%);border:1px solid #4a5158;border-radius:6px;background:#0b0e11;color:#899198;cursor:pointer;touch-action:manipulation}
      .m7-lock-toggle:hover,.m7-lock-toggle:focus-visible{border-color:#b9ff19;color:#b9ff19;outline:none}
      .m7-lock-toggle.locked{border-color:#b9ff19;background:#1b270f;color:#b9ff19;box-shadow:0 0 0 1px #b9ff1933 inset}
      .m7-lock-toggle svg{width:16px;height:16px;fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;pointer-events:none}
      .m7-lock-randomizer{grid-column:1/-1;width:100%;display:grid;grid-template-columns:minmax(190px,1fr) auto;gap:7px;align-items:stretch;margin:5px 0 2px}
      .m7-lock-randomizer button{min-height:44px;border:1px solid #424950;border-radius:7px;background:#11151a;color:#f7f7f3;font-family:inherit;font-size:10px;font-weight:950;line-height:1.15;letter-spacing:.75px;cursor:pointer;touch-action:manipulation;transition:transform .16s ease,border-color .16s ease,background .16s ease,color .16s ease,box-shadow .16s ease}
      .m7-lock-randomizer button:hover,.m7-lock-randomizer button:focus-visible{border-color:#b9ff19;color:#b9ff19;outline:none;transform:translateY(-1px)}
      .m7-lock-randomizer .m7-randomize-unlocked{display:flex;align-items:center;justify-content:center;gap:10px;border-color:#b9ff19;background:#b9ff19;color:#080a0b;box-shadow:0 7px 18px #0007,0 0 0 1px #d6ff75 inset}
      .m7-lock-randomizer .m7-randomize-unlocked:hover,.m7-lock-randomizer .m7-randomize-unlocked:focus-visible{background:#c8ff55;color:#080a0b;box-shadow:0 9px 22px #0009,0 0 0 1px #efffc4 inset}
      .m7-lock-randomizer .m7-randomize-unlocked svg{width:20px;height:20px;fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;flex:none}
      .m7-lock-randomizer .m7-lock-previous{min-width:132px;padding:0 13px;display:flex;align-items:center;justify-content:center;gap:8px;background:#171b20;white-space:nowrap;color:#d9dde1}
      .m7-lock-randomizer .m7-lock-previous svg{width:17px;height:17px;fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;flex:none}
      .m7-lock-randomizer .m7-history-count{min-width:20px;height:20px;padding:0 5px;display:grid;place-items:center;border-radius:999px;background:#2a3036;color:#b9ff19;font-size:9px;line-height:1}
      .m7-lock-randomizer .m7-lock-previous:disabled{opacity:.35;cursor:not-allowed;border-color:#424950;color:#899198}
      .m7-lock-summary{grid-column:1/-1;min-height:27px;display:flex;align-items:center;justify-content:space-between;gap:10px;color:#8e969e;font-size:9px;font-weight:800;letter-spacing:.55px;text-align:left;padding-left:3px}
      .m7-lock-summary b{color:#b9ff19}
      .m7-unlock-all{flex:none;min-height:27px!important;padding:0 10px!important;border-color:#566069!important;background:#171b20!important;color:#d9dde1!important;font-size:8px!important;box-shadow:none!important}
      .m7-unlock-all:hover,.m7-unlock-all:focus-visible{border-color:#b9ff19!important;color:#b9ff19!important;background:#1b2118!important}
      .m7-admin-preset-button{position:fixed;z-index:100040;top:84px;left:50%;min-height:42px;padding:0 18px;transform:translateX(-50%);border:1px solid #d9ff72;border-radius:7px;background:#b9ff19;color:#080a0b;font-family:inherit;font-size:10px;font-weight:950;letter-spacing:.75px;box-shadow:0 10px 28px #000b,0 0 0 1px #efffc4 inset;cursor:pointer;white-space:nowrap;touch-action:manipulation}
      .m7-admin-preset-button:hover,.m7-admin-preset-button:focus-visible{background:#c8ff55;outline:2px solid #ffffff;outline-offset:2px}
      .m7-admin-preset-button.copied{background:#ffffff;color:#080a0b;border-color:#ffffff}
      .m7x-stage.arctic{background:linear-gradient(#ffffff18,#ffffff0c),var(--m7-arctic) center/cover!important}
      .m7-feature-tour[hidden]{display:none!important}
      .m7-feature-tour{position:fixed;inset:0;z-index:100050;pointer-events:none;font-family:inherit}
      .m7-tour-shade{position:fixed;background:rgba(3,6,9,.36);pointer-events:auto}
      .m7-tour-spot{position:fixed;border:2px solid #b9ff19;border-radius:9px;box-shadow:0 0 0 2px #b9ff1930,0 0 24px #b9ff1950;pointer-events:none;transition:all .2s ease}
      .m7-tour-card{position:fixed;width:min(360px,calc(100vw - 24px));padding:18px;border:1px solid #4b535b;border-radius:10px;background:#11151af2;color:#f7f7f3;box-shadow:0 18px 55px #000b;pointer-events:auto}
      .m7-tour-progress{display:flex;align-items:center;justify-content:space-between;margin-bottom:9px;color:#8e969e;font-size:9px;font-weight:900;letter-spacing:1.2px}
      .m7-tour-progress b{color:#b9ff19}
      .m7-tour-card h3{margin:0 0 8px;color:#fff;font-size:19px;line-height:1.05;letter-spacing:-.25px}
      .m7-tour-card p{margin:0;color:#c3c9cf;font-size:12px;line-height:1.55}
      .m7-tour-actions{display:grid;grid-template-columns:auto 1fr auto;gap:7px;margin-top:16px}
      .m7-tour-actions button{min-height:38px;padding:0 13px;border:1px solid #41484f;border-radius:6px;background:#171b20;color:#d9dde1;font-family:inherit;font-size:9px;font-weight:950;letter-spacing:.75px;cursor:pointer}
      .m7-tour-actions button:hover,.m7-tour-actions button:focus-visible{border-color:#b9ff19;color:#b9ff19;outline:none}
      .m7-tour-actions [data-m7-tour-next]{grid-column:3;background:#b9ff19;border-color:#b9ff19;color:#080a0b}
      .m7-tour-actions [data-m7-tour-skip]{grid-column:2;background:transparent;border-color:transparent;color:#8e969e}
      @media(max-width:820px){
        .m7x-zones:not(.parts) [data-m7-zone^="COLOR_"]{padding-right:34px!important}
        .m7-lock-toggle{right:4px;width:28px;height:28px}
        .m7-lock-randomizer{position:sticky;bottom:0;z-index:8;grid-template-columns:minmax(0,1fr) auto;padding:8px 0 4px;margin:5px 0 0;background:linear-gradient(180deg,#10131500,#101315 24%)}
        .m7-lock-randomizer button{min-height:48px;font-size:9px}
        .m7-lock-randomizer .m7-lock-previous{min-width:103px;padding:0 9px;gap:6px}
        .m7-lock-randomizer .m7-lock-previous span:not(.m7-history-count){display:none}
        .m7-tour-shade{background:rgba(3,6,9,.29)}
        .m7-tour-card{width:calc(100vw - 20px);padding:15px}
        .m7-tour-card h3{font-size:17px}
        .m7-tour-card p{font-size:11px}
        .m7-admin-preset-button{top:62px;max-width:calc(100vw - 20px);min-height:38px;padding:0 12px;font-size:8px}
      }
    `;
    document.head.append(style);
  }

  function injectUi(){
    const editor=document.getElementById("m7WrapEditor");
    if(!editor)return;
    const zones=editor.querySelector(".m7x-zones:not(.parts)");
    if(!zones)return;

    zones.querySelectorAll('[data-m7-zone^="COLOR_"]').forEach(button=>{
      const role=button.dataset.m7Zone;
      let toggle=button.querySelector(".m7-lock-toggle");
      if(!toggle){
        toggle=document.createElement("span");
        toggle.className="m7-lock-toggle";
        toggle.setAttribute("role","button");
        toggle.setAttribute("tabindex","0");
        toggle.dataset.m7LockZone=role;
        button.append(toggle);
      }
      updateLock(toggle,role);
    });

    let controls=zones.querySelector(":scope > .m7-lock-randomizer");
    if(!controls){
      controls=document.createElement("div");
      controls.className="m7-lock-randomizer";
      zones.append(controls);
    }
    const count=activeZones().filter(role=>locked.has(role)).length;
    const signature=[busy,history.length,count].join(":");
    if(controls.dataset.state===signature)return;
    controls.dataset.state=signature;
    controls.innerHTML=`
      <button type="button" class="m7-randomize-unlocked" data-m7-randomize-unlocked ${busy?"disabled":""}>
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h3c5 0 5 10 10 10h5"></path><path d="m18 14 3 3-3 3"></path><path d="M3 17h3c5 0 5-10 10-10h5"></path><path d="m18 4 3 3-3 3"></path></svg>
        <span>${busy?"BUILDING VARIATION...":"RANDOMIZE UNLOCKED"}</span>
      </button>
      <button type="button" class="m7-lock-previous" data-m7-lock-previous ${history.length?"":"disabled"}>
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 7H4v-5"></path><path d="M4.5 7.5A9 9 0 1 1 3 15"></path></svg>
        <span>PREVIOUS</span><b class="m7-history-count">${history.length}</b>
      </button>
      <span class="m7-lock-summary">
        <span>${count?`<b>${count}</b> COLOR${count===1?"":"S"} LOCKED — UNLOCKED WRAP COLORS WILL CHANGE`:`NO COLORS LOCKED — ALL WRAP COLORS WILL CHANGE`}</span>
        ${count?`<button type="button" class="m7-unlock-all" data-m7-unlock-all>UNLOCK ALL</button>`:""}
      </span>`;
  }

  function clickTab(name){
    const editor=document.getElementById("m7WrapEditor");
    const tab=editor?.querySelector(`.m7x-tabs [data-m7-tab="${name}"]`);
    if(tab&&!tab.classList.contains("active"))tab.click();
  }

  async function returnToWrapColors(){
    clickTab("custom");
    await wait();
    const wrap=document.getElementById("m7WrapEditor")?.querySelector('[data-m7-group="wrap"]');
    if(wrap&&!wrap.classList.contains("active"))wrap.click();
    await wait();
    injectUi();
  }

  async function randomizeUnlocked(){
    if(busy||!window.M7Editor?.getSnapshot||!window.M7Editor?.applyPaints)return;
    const before=clone(M7Editor.getSnapshot());
    const unlocked=before.activeZones.filter(role=>!locked.has(role));
    if(!unlocked.length){
      injectUi();
      return;
    }

    busy=true;
    injectUi();
    try{
      const variation=buildVariation(before,unlocked);
      history.push(before);
      if(history.length>3)history.shift();
      M7Editor.applyPaints(variation.paints,variation.name);
      await returnToWrapColors();
    }catch(error){
      console.error("M7 locked randomizer:",error);
      M7Editor.applyPaints(before.paints,before.designName||before.name);
      await returnToWrapColors();
    }finally{
      busy=false;
      injectUi();
    }
  }

  async function previousVariation(){
    if(busy||!history.length||!window.M7Editor?.applyPaints)return;
    const previous=history.pop();
    busy=true;
    injectUi();
    M7Editor.applyPaints(previous.paints,previous.designName||previous.name);
    await returnToWrapColors();
    busy=false;
    injectUi();
  }

  function toggleLock(toggle){
    const role=toggle.dataset.m7LockZone;
    if(!role)return;
    locked.has(role)?locked.delete(role):locked.add(role);
    saveLocks();
    updateLock(toggle,role);
    injectUi();
  }

  function unlockAll(){
    if(!locked.size)return;
    locked.clear();
    saveLocks();
    injectUi();
  }

  function adminPresetValue(){
    if(!window.M7Editor?.getSnapshot)return"";
    const snapshot=M7Editor.getSnapshot();
    const color=role=>snapshot.paints?.[role]?.a||"";
    return [
      "M7P2",
      encodeURIComponent(snapshot.designName||"Quick Style"),
      "",
      Array.from({length:10},(_,index)=>color(`COLOR_${index+1}`)).join(","),
      PARTS.map(color).join(",")
    ].join("|");
  }

  async function writeClipboard(value){
    if(navigator.clipboard?.writeText){
      await navigator.clipboard.writeText(value);
      return;
    }
    const field=document.createElement("textarea");
    field.value=value;
    field.setAttribute("readonly","");
    field.style.cssText="position:fixed;left:-9999px;top:0";
    document.body.append(field);
    field.select();
    const copied=document.execCommand("copy");
    field.remove();
    if(!copied)throw new Error("Clipboard copy was blocked");
  }

  function installAdminPresetButton(){
    if(!new URLSearchParams(location.search).has("m7admin"))return;
    let button=document.getElementById("m7AdminPresetButton");
    if(!button){
      button=[...document.querySelectorAll("body > button")].find(node=>(node.textContent||"").trim()==="ADMIN PRESET");
    }
    if(!button){
      button=document.createElement("button");
      button.type="button";
      document.body.append(button);
    }
    button.id="m7AdminPresetButton";
    button.className="m7-admin-preset-button";
    button.textContent="COPY QUICK STYLE FOR SHOPIFY";
    button.setAttribute("aria-label","Copy this colorway for a Shopify Quick Style metafield");
    button.onclick=async event=>{
      event.preventDefault();
      event.stopPropagation();
      const value=adminPresetValue();
      if(!value)return;
      try{
        await writeClipboard(value);
        button.classList.add("copied");
        button.textContent="COPIED — PASTE INTO SHOPIFY";
        setTimeout(()=>{
          button.classList.remove("copied");
          button.textContent="COPY QUICK STYLE FOR SHOPIFY";
        },2200);
      }catch(error){
        console.error("M7 admin preset copy:",error);
        button.textContent="COPY BLOCKED — TRY AGAIN";
        setTimeout(()=>button.textContent="COPY QUICK STYLE FOR SHOPIFY",2400);
      }
    };
  }

  function ensureTour(){
    let tour=document.getElementById("m7FeatureTour");
    if(tour)return tour;
    tour=document.createElement("div");
    tour.id="m7FeatureTour";
    tour.className="m7-feature-tour";
    tour.hidden=true;
    tour.innerHTML=`
      <div class="m7-tour-shade" data-m7-shade="top"></div>
      <div class="m7-tour-shade" data-m7-shade="right"></div>
      <div class="m7-tour-shade" data-m7-shade="bottom"></div>
      <div class="m7-tour-shade" data-m7-shade="left"></div>
      <div class="m7-tour-spot"></div>
      <section class="m7-tour-card" role="dialog" aria-modal="true" aria-label="M7 editor walkthrough">
        <div class="m7-tour-progress"><span>EDITOR WALKTHROUGH</span><b></b></div>
        <h3></h3><p></p>
        <div class="m7-tour-actions">
          <button type="button" data-m7-tour-back>BACK</button>
          <button type="button" data-m7-tour-skip>SKIP</button>
          <button type="button" data-m7-tour-next>NEXT</button>
        </div>
      </section>`;
    document.body.append(tour);
    return tour;
  }

  function setBox(element,left,top,width,height){
    element.style.left=Math.max(0,left)+"px";
    element.style.top=Math.max(0,top)+"px";
    element.style.width=Math.max(0,width)+"px";
    element.style.height=Math.max(0,height)+"px";
  }

  function positionTour(target){
    const tour=ensureTour();
    if(tour.hidden||!target)return;
    const viewportWidth=innerWidth;
    const viewportHeight=innerHeight;
    const raw=target.getBoundingClientRect();
    const padding=7;
    const left=Math.max(5,raw.left-padding);
    const top=Math.max(5,raw.top-padding);
    const right=Math.min(viewportWidth-5,raw.right+padding);
    const bottom=Math.min(viewportHeight-5,raw.bottom+padding);

    setBox(tour.querySelector('[data-m7-shade="top"]'),0,0,viewportWidth,top);
    setBox(tour.querySelector('[data-m7-shade="bottom"]'),0,bottom,viewportWidth,viewportHeight-bottom);
    setBox(tour.querySelector('[data-m7-shade="left"]'),0,top,left,bottom-top);
    setBox(tour.querySelector('[data-m7-shade="right"]'),right,top,viewportWidth-right,bottom-top);
    setBox(tour.querySelector(".m7-tour-spot"),left,top,right-left,bottom-top);

    const card=tour.querySelector(".m7-tour-card");
    card.style.visibility="hidden";
    card.style.left="12px";
    card.style.top="12px";
    requestAnimationFrame(()=>{
      const cardWidth=card.offsetWidth;
      const cardHeight=card.offsetHeight;
      let cardLeft=Math.min(viewportWidth-cardWidth-12,Math.max(12,left+(right-left-cardWidth)/2));
      let cardTop=bottom+13;
      if(cardTop+cardHeight>viewportHeight-12)cardTop=top-cardHeight-13;
      if(cardTop<12)cardTop=Math.min(viewportHeight-cardHeight-12,Math.max(12,bottom-cardHeight-13));
      if(viewportWidth<=820){
        cardLeft=10;
        cardTop=viewportHeight-cardHeight-10;
      }
      card.style.left=cardLeft+"px";
      card.style.top=Math.max(10,cardTop)+"px";
      card.style.visibility="visible";
    });
  }

  async function renderTour(){
    const tour=ensureTour();
    const step=TOUR_STEPS[tourIndex];
    const editor=document.getElementById("m7WrapEditor");
    if(step.tab){
      const panel=editor?.querySelector(".m7x-panel");
      if(panel&&!panel.classList.contains("open"))editor.querySelector('[data-m7-action="panel"]')?.click();
      clickTab(step.tab);
      await wait();
    }
    if(step.group){
      const group=editor?.querySelector(`[data-m7-group="${step.group}"]`);
      if(group&&!group.classList.contains("active"))group.click();
      await wait();
    }
    const target=document.querySelector(step.target)||editor?.querySelector(".m7x-stage")||editor;
    const rect=target?.getBoundingClientRect();
    if(rect&&(rect.bottom<0||rect.top>innerHeight)){
      target.scrollIntoView({behavior:"smooth",block:"nearest",inline:"nearest"});
      await new Promise(resolve=>setTimeout(resolve,240));
    }
    tour.querySelector(".m7-tour-progress b").textContent=`${tourIndex+1} / ${TOUR_STEPS.length}`;
    tour.querySelector("h3").textContent=step.title;
    tour.querySelector("p").textContent=step.text;
    tour.querySelector("[data-m7-tour-back]").disabled=tourIndex===0;
    tour.querySelector("[data-m7-tour-next]").textContent=tourIndex===TOUR_STEPS.length-1?"DONE":"NEXT";
    positionTour(target);
  }

  async function openTour(){
    const editor=document.getElementById("m7WrapEditor");
    const activeTab=editor?.querySelector(".m7x-tabs [data-m7-tab].active")?.dataset.m7Tab||"presets";
    const activeGroup=editor?.querySelector("[data-m7-group].active")?.dataset.m7Group||"wrap";
    tourRestore={tab:activeTab,group:activeGroup};
    tourIndex=0;
    const tour=ensureTour();
    tour.hidden=false;
    await renderTour();
  }

  async function closeTour(){
    const tour=ensureTour();
    tour.hidden=true;
    if(!tourRestore)return;
    clickTab(tourRestore.tab);
    await wait();
    const group=document.getElementById("m7WrapEditor")?.querySelector(`[data-m7-group="${tourRestore.group}"]`);
    if(group&&!group.classList.contains("active"))group.click();
    tourRestore=null;
  }

  async function moveTour(direction){
    if(direction>0&&tourIndex===TOUR_STEPS.length-1){
      await closeTour();
      return;
    }
    tourIndex=Math.max(0,Math.min(TOUR_STEPS.length-1,tourIndex+direction));
    await renderTour();
  }

  function install(){
    const editor=document.getElementById("m7WrapEditor");
    if(!editor||editor.dataset.m7LockRandomizer==="true")return;
    editor.dataset.m7LockRandomizer="true";
    injectStyles();
    installAdminPresetButton();

    const closeLegacyGuide=()=>{
      const legacy=document.getElementById("m7Guide");
      if(!legacy)return;
      if(legacy.classList.contains("open"))legacy.classList.remove("open");
      if(legacy.getAttribute("aria-hidden")!=="true")legacy.setAttribute("aria-hidden","true");
      document.querySelectorAll(".m7x-guide-target").forEach(node=>node.classList.remove("m7x-guide-target"));
    };
    closeLegacyGuide();
    const legacyGuideObserver=new MutationObserver(closeLegacyGuide);
    legacyGuideObserver.observe(document.body,{subtree:true,attributes:true,attributeFilter:["class","aria-hidden"]});

    document.addEventListener("click",event=>{
      const help=event.target.closest('[data-m7-action="help"]');
      if(help){
        event.preventDefault();
        event.stopImmediatePropagation();
        openTour();
        return;
      }
      if(event.target.closest("[data-m7-tour-back]")){
        event.preventDefault();
        event.stopImmediatePropagation();
        moveTour(-1);
      }else if(event.target.closest("[data-m7-tour-next]")){
        event.preventDefault();
        event.stopImmediatePropagation();
        moveTour(1);
      }else if(event.target.closest("[data-m7-tour-skip]")){
        event.preventDefault();
        event.stopImmediatePropagation();
        closeTour();
      }
    },true);
    document.addEventListener("keydown",event=>{
      if(event.key==="Escape"&&!ensureTour().hidden)closeTour();
    });
    const repositionTour=()=>{
      const tour=document.getElementById("m7FeatureTour");
      if(tour&&!tour.hidden){
        const step=TOUR_STEPS[tourIndex];
        const target=document.querySelector(step.target)||document.querySelector("#m7WrapEditor .m7x-stage");
        positionTour(target);
      }
    };
    addEventListener("resize",repositionTour,{passive:true});
    addEventListener("scroll",repositionTour,{passive:true});

    editor.addEventListener("pointerdown",event=>{
      if(event.target.closest(".m7-lock-toggle"))event.stopPropagation();
    },true);
    editor.addEventListener("click",event=>{
      const toggle=event.target.closest(".m7-lock-toggle");
      if(toggle){
        event.preventDefault();
        event.stopImmediatePropagation();
        toggleLock(toggle);
        return;
      }
      if(event.target.closest("[data-m7-unlock-all]")){
        event.preventDefault();
        event.stopImmediatePropagation();
        unlockAll();
        return;
      }
      if(event.target.closest("[data-m7-randomize-unlocked]"))randomizeUnlocked();
      if(event.target.closest("[data-m7-lock-previous]"))previousVariation();
    },true);
    editor.addEventListener("keydown",event=>{
      const toggle=event.target.closest(".m7-lock-toggle");
      if(toggle&&(event.key==="Enter"||event.key===" ")){
        event.preventDefault();
        event.stopImmediatePropagation();
        toggleLock(toggle);
      }
    },true);

    const observer=new MutationObserver(()=>requestAnimationFrame(injectUi));
    observer.observe(editor,{childList:true,subtree:true});
    const toastObserver=new MutationObserver(()=>{
      document.querySelectorAll(".m7x-toast").forEach(toast=>{
        if(/new mix generated with\s+\d+\s+gradient zone/i.test(toast.textContent||""))toast.remove();
      });
    });
    toastObserver.observe(document.body,{childList:true,subtree:true});
    injectUi();
  }

  if(document.readyState==="loading"){
    document.addEventListener("DOMContentLoaded",()=>setTimeout(install,450));
  }else{
    setTimeout(install,450);
  }
  document.addEventListener("shopify:section:load",()=>setTimeout(install,150));
})();
